<template>
  <el-dialog
    class="theme-dialog dialog-center dialog-body-0"
    title="评价成功"
    width="890px"
    top="0"
    :center="true"
    :close-on-click-modal="false"
    :visible.sync="visibility"
  >
    <div class="py-8 box-border flex flex-col items-center justify-center">
      <p class="mb-6 text-theme-black-850 text-large leading-22 font-semibold">评价成功，可前往查看评论</p>
      <div style="width: 755px; height: 480px;">
        <img class="w-full h-full" :src="`${baseUrl}img/comment_guide.png`"/>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog'

export default {
  name: 'CommentSuccessDialog',
  mixins: [dialogMixins],
}
</script>